import { Editor, Path } from 'slate';

export const getNextInsertionPoint = (editor: Editor, nodePath: Path): Path => {
  const nextNodePath = [...nodePath];
  const maybeNextInsertionPoint = Editor.after(editor, nodePath);
  if (maybeNextInsertionPoint != null) {
    return maybeNextInsertionPoint as unknown as Path;
  }
  const pointAfter = nodePath[nodePath.length - 1] + 1;
  nextNodePath[nextNodePath.length - 1] = pointAfter;
  return nextNodePath as unknown as Path;
};
